import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import useStore from '../../../store';

interface IPayload {
  'version': string,
  'results': {question: string, answer: string }[]
}

export const postUploadEdd = () => {
  const { user: { customerId }, getPersonalAccount } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();
  return useMutation(
    'postUploadEdd',
    async (payload: IPayload) => {
      const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/international/wire/out/edd`, { ...payload });
      return data;
    },
  );
};
